import { render, staticRenderFns } from "./HistorialLabs.vue?vue&type=template&id=6e86b0b9"
import script from "./HistorialLabs.vue?vue&type=script&lang=js"
export * from "./HistorialLabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports